function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { presets as timingFunction } from '@okee-uikit/react-utils';

function getChildRefKey(element) {
  if (typeof element.type === 'string') {
    return 'ref';
  }

  return 'domRef';
}

function breadcrumbEnterTick(domNode, percent) {
  if (percent >= 1) {
    domNode.style.removeProperty('opacity');
    domNode.style.removeProperty('transform');
  } else if (percent >= 0.5) {
    percent = timingFunction.easeOut((percent - 0.5) * 2);
    domNode.style.setProperty('opacity', percent.toFixed(4));
    domNode.style.setProperty('transform', "translate3d(".concat((1 - percent) * 4, "px, 0px, 0px)"));
  }
}

function breadcrumbLeaveTick(domNode, percent) {
  if (percent <= 0.5) {
    percent = timingFunction.easeIn(percent * 2);
    domNode.style.setProperty('opacity', (1 - percent).toFixed(4));
    domNode.style.setProperty('transform', "translate3d(".concat(percent * 4, "px, 0px, 0px)"));
  } else if (domNode.style.getPropertyValue('display') !== 'none') {
    domNode.style.setProperty('display', 'none');
  }
}

function rewriteStyleOfEnteringItem(props) {
  return {
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      opacity: 0,
      transform: 'translate3d(4px, 0px, 0px)'
    })
  };
}

export var SegmentedAnimation = function SegmentedAnimation(duration) {
  return {
    duration: duration * 2,
    timingFunction: 'linear',
    ignoreInitialRender: true,
    childRefKey: getChildRefKey,
    enterTick: breadcrumbEnterTick,
    leaveTick: breadcrumbLeaveTick,
    enterChildProps: rewriteStyleOfEnteringItem
  };
};